import React from "react";
import "./Video_Section.css";

const Video_Section = () => {
  return (
    <section className="video_section">
      <video
        className="bg_video"
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src={process.env.PUBLIC_URL + "/assets/videos/banner_video2.mp4"}
          type="video/mp4"
        />
      </video>

      <div className="video_overlay">
        <div className="container">
          <div className="video_content">
            <span className="sub_title">
              Seedso Agriculture
            </span>

            <h2>
              We Provide
              <span> Sustainable Solutions</span>
            </h2>

            <p>
              Empowering farmers with premium seeds, fertilizers, crop
              protection, and innovative agricultural solutions for healthier
              crops and higher yields.
            </p>

            <a href="/products" className="video_btn">
              Explore Products
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Video_Section;